import { Box, ColorOptions, Image, Loader, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { Dimensions, ScrollView } from 'react-native'
import EmptyView from '../../comps/EmptyView'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SvgImage } from '../../comps/SvgImage'
import { Toast, ToastPosition, ToastType } from '../../comps/Toast'
import { useLazyApiData, useStores } from '../../data/store'
import { Colors, ENABLE_QR_OPTIMIZATION, getBase64Image, hasPermissions, isOsMobile, testProps } from '../../util/util'

import { MerchantDetail } from './MerchantDetail'
import { ShareImage } from './Share.web'
import { styles } from './style'

const { height } = Dimensions.get('window')

export const testData = {
  data: {
    transactionList: [
      {
        transaction: {
          id: '10442324439165738000',
          originalId: '10442324439165738000',
          idempotentKey: 'oIqFslKL',
          initiatingEntityTimestamp: '2023-09-01T10:51:18.471Z',
          created: '2023-09-01T10:52:45.738Z',
          currency: 356,
          metadata: {
            returnData: {},
            processorTransactionId: 'U4560001474259',
          },
          mode: 1,
          method: {
            type: 110,
            subType: 582,
          },
          status: 'SUCCESS',
          application: 8006,
          livemode: true,
          initiatingEntity: {
            entityId: 2103,
            callbackUrl: 'https://enj6cgky4bjgsk0.m.pipedream.net',
            returnUrl: 'https://psp-mandate-merchant-sit.jiomoney.com:3003/merchantsimulator/sit/merchantstatus',
            groupId: '106523090908600',
            subGroupId: '106523090078100',
          },
          invoice: 'JIO0000001',
          responseTime: '2023-09-01T10:53:45.738Z',
          processorTransactionId: 'U4560001474259',
          intentId: '10442324439078671000',
          referenceNumber: '190001062185',
          description: 'Payment',
          expireAfter: '30',
        },
        amount: {
          netAmount: 12.0,
          grossAmount: 12.0,
        },
        payer: {
          externalId: 'JIO1234',
          name: 'test',
          email: 'user@xyz.com',
          card: {
            type: 110,
            scheme: 104,
            maskedNumber: 'XXXXXXXXXXXX0055',
            name: 'XXXXXXXXX',
          },
          mobile: {
            countryCode: '91',
            number: '8697808037',
          },
          bankId: '1038',
          bankName: 'STATE BANK OF INDIA',
          type: 11,
        },
        payee: {
          terminalId: '10232760',
          merchantId: '100001000217423',
          name: 'ABC',
          email: 'mohit.bharambe@ril.com',
          mobile: {
            countryCode: '+91',
            number: '9882889337',
          },
          vpa: 'newvpa-np002@jiopay',
          type: 16,
        },
      },
    ],
  },
  status: 'error',
}

const QRcodeV2: FC = () => {
  const { getQrCode, vpa, downloadQRCode, setMessage, mid, updateVpaFromStore, merchantName } = useStores((root) => ({
    getQrCode: root.user.getQrCode,
    vpa: root.settings.metaData.vpa,
    downloadQRCode: root.user.downloadQRCode,
    setMessage: root.response.setMessage,
    date: root.transactions.date,
    mid: root.user.selectedMid,
    updateVpaFromStore: root.user.updateVpaFromStore,

    merchantName: root?.settings?.metaData?.selectedMercName,
  }))

  const [isLocal, setIsLocal] = useState(false)
  const [txnId] = useState('')
  const [defaultQrModalVisible] = useState(true)
  const [fetchStateQr, { state: fetchQrState, data: fetchQrData }] = useLazyApiData(getQrCode)
  const [donwloadQr, donwloadHandler] = useLazyApiData(downloadQRCode)
  const [shareQr, sharehandler] = useLazyApiData(downloadQRCode)
  const [amount] = useState('')
  const [imgUri, setImageUri] = useState('')
  const [toastVisible, setToastVisible] = useState(false)
  const isFocused = useIsFocused()

  // navigation.setOptions({ headerShown: false })

  const checkIfFileAlreadyDownloaded = async (midSelected: string) => {
    //store in base64 image for selected mid and show
    const qr = sessionStorage.getItem(midSelected)
    if (!qr) {
      setIsLocal(false)
      setImageUri('')
      console.log('File not available, downloading qr for mid ', qr, mid)
      fetchStateQr()
    } else {
      setImageUri(qr)
      setIsLocal(true)
    }
  }

  useEffect(() => {
    setToastVisible(donwloadHandler?.data?.status === 200)
  }, [donwloadHandler.data])

  //@todo
  useEffect(() => {
    hasPermissions()
      .then((value) => {
        console.log('File write permission granted', value)
      })
      .catch(() => {
        console.log('File write permission not provided')
      })
  }, [])

  useEffect(() => {
    if (isFocused && !amount) {
      if (ENABLE_QR_OPTIMIZATION) {
        updateVpaFromStore()
        checkIfFileAlreadyDownloaded(mid)
      } else {
        fetchStateQr()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, amount, mid])

  useEffect(() => {
    if (fetchQrState === 'fulfilled' && fetchQrData?.status === 'SUCCESS') {
      const base64Image = getBase64Image(fetchQrData?.qr)
      setImageUri(base64Image)
      setIsLocal(true)
      if (ENABLE_QR_OPTIMIZATION) {
        if (mid && mid.length > 0 && base64Image && base64Image.length > 0) {
          sessionStorage.setItem(mid, base64Image)
        }
      }
      console.log('File api state fulfilled saving file to phone')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchQrState, fetchQrData])

  const handleRetry = (): void => {
    mid && fetchStateQr(mid)
  }

  const handleDownload = () => {
    hasPermissions().then((value) => {
      if (value) {
        donwloadQr(amount, txnId)
      } else {
        setMessage('Permissions not granted')
      }
    })
  }

  const handleShare = () => {
    shareQr(amount, txnId, true)
  }

  const handleDismiss = () => {
    setToastVisible(false)
  }

  const handleAction = () => {
    setToastVisible(false)
  }

  // if (!isLocal && fetchQrState === 'rejected') {
  //   return (
  //     <Box alignSelf="center" justifyContent="center" height="100%" alignItems="center" bg={'BLACK'} w={'100%'}>
  //       <Text fontSize={16} color="LIGHT_BLACK">
  //         {fetchQrData?.data?.error?.message ?? 'An error has occured'}
  //       </Text>
  //       <Spacer direction="vertical" size={20} />
  //       <ButtonNew
  //         onPress={() => {
  //           fetchStateQr()
  //         }}
  //         title="Retry"
  //         width={100}
  //         height={36}
  //         color={'PRIMARY'}
  //       />
  //     </Box>
  //   )
  // }

  return (
    <Box backgroundColor={'SECONDARY'} flex={1} alignItems="center" position={'relative'}>
      <Toast
        message={'QR successfully saved in your gallery'}
        hide={!toastVisible}
        position={ToastPosition.BOTTOM}
        type={ToastType.ACTION_VIEW}
        onDismiss={handleDismiss}
        onAction={handleAction}
        timeOut={5000}
      />

      <ModBox height={200} width={'100%'} alignItems={'center'} justify="center">
        <Box {...styles.ripple1(110)} zIndex={-1} position={'absolute'} />
        <Box {...styles.ripple2(150)} zIndex={-1} position={'absolute'} />
      </ModBox>
      <ModBox height={200} width={'100%'} position="absolute" alignItems={'center'} justify="center" zIndex={9}>
        <Box
          backgroundColor={Colors.PRIMARY as ColorOptions}
          width={70}
          height={70}
          borderRadius={70}
          justifyContent="center"
          position={'absolute'}
          alignItems={'center'}>
          <SvgImage imageName="store" color={'#fff'} />
        </Box>
      </ModBox>

      <ModBox
        show={defaultQrModalVisible}
        position={'absolute'}
        height={height - 160}
        width={'100%'}
        flex={1}
        bottom={0}
        paddingBottom={16}
        alignItems="center"
        borderTopLeftRadius={35}
        borderTopRightRadius={35}
        overflowY="hidden"
        zIndex={8}
        backgroundColor={'WHITE'}>
        <ScrollView
          contentContainerStyle={{
            alignItems: 'center',
            justifyContent: 'space-around',
            flex: 1,
          }}
          style={{
            ...styles.scrollviewStyle,
            overflow: 'auto',
            width: '100%',
            borderTopLeftRadius: 30,
            borderTopRightRadius: 30,
            backgroundColor: '#fff',
          }}>
          <Box zIndex={15}>
            <Spacer size={58} direction="vertical" />
            <MerchantDetail merchantName={merchantName} vpa={vpa} imgUri={imgUri} color={'BLACK'} />
          </Box>

          <ModBox {...styles.progressEmptyView} show={isEmpty(imgUri)}>
            <EmptyView
              onRetry={handleRetry}
              isLoading={fetchQrState === 'pending'}
              error={fetchQrState !== 'pending' && fetchQrData?.message}
              emptyMessage={'QR Code not generated please retry'}
              loadingMessage={'loading'}
              hide={(fetchQrState !== 'pending' && fetchQrState !== 'rejected') || isLocal}
            />
          </ModBox>
          <Box>
            <ModBox {...styles.qrImgcontainer} show={imgUri?.length > 0}>
              <Image {...styles.imageView} resizeMode="contain" source={imgUri} />
            </ModBox>
            <ModBox
              show={imgUri?.length > 0}
              paddingVertical="TINY"
              flexDirection="row"
              alignItems={'center'}
              justify="center">
              {isOsMobile() && <ShareImage handleShare={handleShare} sharehandler={sharehandler} />}
              {isOsMobile() && <Spacer size="MEDIUM" direction="horizontal" />}
              <Box
                flexDirection="row"
                alignItems="center"
                underlayColor="PRIMARY_LIGHT_GREY"
                {...testProps('donwload-qr-button')}
                onPress={handleDownload}>
                {donwloadHandler.state === 'pending' ? (
                  <Loader color={'PRIMARY'} type="small" />
                ) : (
                  <SvgImage imageName={'Download'} color={Colors.PRIMARY} />
                )}
                <Spacer size="TINY" direction="horizontal" />
                <Text color="PRIMARY" fontSize={14} fontFamily={'JioType-Medium'}>
                  Download
                </Text>
              </Box>
            </ModBox>
          </Box>
          <Box {...styles.bhim}>
            <SvgImage imageName={'BhimUpi'} />
          </Box>
        </ScrollView>
      </ModBox>
    </Box>
  )
}

const shadowStyle = {
  shadowOffset: { width: 1, height: 2 },
  shadowRadius: 5,
  shadowColor: '#0000001F',
  borderRadius: 24,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

export default QRcodeV2
